<template>
  <th class="subsearch-toggle-area-bar" id="detailedsearch_tit_work_content">
    <p class="detailedsearch_tit">
      企画内容
    </p>

    <ul class="detailedsearch_list">
      <li v-for="item in workContentsStore.master" :key="item.code">
        <label :for="`work_contents_${item.code}`">
          <input type="checkbox"
                v-model="checkboxValue"
                :id="`work_contents_${item.code}`"
                :value="item.code">
          <span>{{ item.text }}</span>
        </label>
      </li>
    </ul>
  </th>
</template>

<script setup>
import { computed, inject } from 'vue'

const workContentsStore = inject('workContentsStore')
const checkboxValue = computed({
  get: () => workContentsStore.workContents.value,
  set: (value) => workContentsStore.set(value)
})
</script>
